const locale = {
  loadComplete: 'Loading complete'
};

export default locale;
